import React, { useContext } from "react";
import "./Services.css";
import Card from "../Card/Card";
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import Resume from "./resume.pdf";

const Services = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  const transition = {
    duration: 1,
    type: "spring",
  };

  return (
    <div className="services" id="services">
      {/* left side */}
      <div className="awesome">
        {/* dark mode */}
        <span style={{ color: darkMode ? "white" : "" }}>My Internship</span>
        <span>Experiences</span>
        <spane>
          Gained highly real-time experience working with these organizations
          <br />
          Now, there is a change in the way I look at the Technology😂
        </spane>
        <a href={Resume} download>
          <button className="button s-button">⬇️ My Resume</button>
        </a>
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      {/* right */}
      <div className="cards">
        {/* first card */}
        <motion.div
          initial={{ left: "25rem" }}
          whileInView={{ left: "14rem" }}
          transition={transition}
        >
          <Card
            emoji={HeartEmoji}
            heading={"IIITH"}
            detail={
              "Research Intern @ IIITH and worked on projects like cancer detection in cells and EDRI application"
            }
            link={
              "https://drive.google.com/file/d/1G8kwiDfvwpIVWOTKne5QYW3PEFfOyTGf/view?usp=sharing"
            }
          />
        </motion.div>
        {/* second card */}
        <motion.div
          initial={{ left: "-11rem", top: "12rem" }}
          whileInView={{ left: "-4rem" }}
          transition={transition}
        >
          <Card
            emoji={Glasses}
            heading={"The Sparks Foundation"}
            detail={"Training/Internship related to Full-Stack Web Development"}
            link={
              "https://drive.google.com/file/d/1NuhFSG3Rfcek9T4DOsb7nhgzJaRNLyti/view?usp=sharing"
            }
          />
        </motion.div>
        {/* 3rd */}
        <motion.div
          initial={{ top: "19rem", left: "25rem" }}
          whileInView={{ left: "12rem" }}
          transition={transition}
        >
          <Card
            emoji={Humble}
            heading={"Tech Mihir Naik"}
            detail={"Frontend Developer"}
            color="rgba(252, 166, 31, 0.45)"
            link={
              "https://drive.google.com/file/d/1Fk4vCHWkBpWuzQQvSZj4V6R0K25GFCX3/view?usp=sharing"
            }
          />
        </motion.div>
        <div
          className="blur s-blur2"
          style={{ background: "var(--purple)" }}
        ></div>
      </div>
    </div>
  );
};

export default Services;
